<template>
  <view class="container">
    <view class="title">旅行时间</view>
    <view class="options">
      <view
        wx:for="{{dateOptions.months}}"
        wx:key="value"
        class="option"
        wx:class="{{ {active:item.active} }}"
        bindtap="onSelect('months', item)"
      >{{item.label}}</view>
    </view>
    <view class="title">周几出发</view>
    <view class="options">
      <view
        wx:for="{{dateOptions.weeks}}"
        wx:key="value"
        class="option"
        wx:class="{{ {active:item.active} }}"
        bindtap="onSelect('weeks', item)"
      >{{item.label}}</view>
    </view>
    <view bindtap="onConfirm" class="footer-button">确定</view>
  </view>
</template>
<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import dayjs from 'dayjs'
  import { utils } from '@didi/webx-js'

  createComponent({
    properties: {
      fuzzyDate: {
        type: Object,
        value: null
      },
    },
    data: {
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      months: [],
      fuzzyOptions: {},
    },
    computed: {
      dateOptions() {
        const {
          weeks = [],
          months = [],
        } = this.fuzzyOptions
        return {
          weeks: this.weeks.map((i, idx) => ({
            label: i,
            value: idx,
            active: weeks.includes(idx)
          })),
          months: this.months.map(({label, value}) => ({
            label,
            value,
            active: months.includes(value)
          }))
        }
      }
    },
    created() {
      this.fuzzyOptions = utils.cloneDeep(this.fuzzyDate || {})
      const currentDate = dayjs()
      this.months = [0, 1, 2, 3].map(i => {
        const item = currentDate.add(i, 'M')
        return {
          label: item.format('M月'),
          value: item.format('YYYY-MM'),
        }
      })
    },
    methods: {
      onSelect(type, detail) {
        const { value } = detail
        const selected = this.refreshSelectedOptions(this.fuzzyOptions[type], value)
        this.$set(this.fuzzyOptions, type, selected)
      },
      refreshSelectedOptions(arr=[], val) {
        const _arr = arr.slice()
        const idx = arr.findIndex(i => i===val)
        if(idx>-1) {
          _arr.splice(idx, 1)
        }else {
          _arr.push(val)
        }
        return _arr
      },
      onConfirm() {
        if(!this.fuzzyOptions.months?.length) {
          mpx.showToast({
            title: '请至少选择一个月份',
            icon: 'none',
          })
          return
        }
        this.triggerEvent('confirm', this.fuzzyOptions)
      }
    }
  })
</script>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>

<style lang="stylus" scoped>
.container
  height 479px
  background-color #fff
  font-family PingFang SC
  color #333
  padding 0 14px
  position relative
  .footer-button
    background #FF6400
    border-radius 10px
    display flex
    align-items center
    justify-content center
    color #fff
    font-weight 600
    font-size 16px
    height 50px
    position absolute
    bottom 34px
    width calc(100% - 28px)
  .title
   padding 24px 0 16px 0
   display flex
   align-items center
   font-weight 600
   font-size 16px
   line-height 1
   &:first-child
    padding-top 12px
  .options
    display flex
    align-items center
    justify-content space-between
    .option
      flex-grow 1
      background #F6F7F8
      margin-right 8px
      height 42px
      display flex
      align-items center
      justify-content center
      border-radius 8px
      font-weight 400
      font-size 14px
      box-sizing border-box
      border 1px solid #fff
      overflow hidden
      &:last-child
        margin-right 0
      &.active
        background #fff
        border-color #FF6400
        position relative
        &:after {
          content ''
          position absolute
          width 18px
          height 14px
          right -1px
          bottom -1px
          background-image url("https://dpubstatic.udache.com/static/dpubimg/sJ9KdDopDQpQoKQX0zqOD.png")
          background-size 100% 100%
}
</style>